import { render, staticRenderFns } from "./TicketGate.vue?vue&type=template&id=3a8d45fd"
import script from "./TicketGate.vue?vue&type=script&lang=js"
export * from "./TicketGate.vue?vue&type=script&lang=js"
import style0 from "./TicketGate.vue?vue&type=style&index=0&id=3a8d45fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports